import MicroModal from 'micromodal';
import i18n from 'roddeh-i18n';
export default class OpensetModal {
    static init(modal, sku) {
        const addButton = modal.querySelector('.md-add-action');
        if (addButton) {
            addButton.addEventListener('click', () => {
                const formData = new FormData();
                formData.append('sku', sku);
                formData.append('quantity', '1');
                fetch('/cart/addopenset?csrc=openset', {
                    method: 'POST',
                    cache: 'no-cache',
                    body: formData,
                })
                    .then((response) => {
                    if (response.ok === false) {
                        throw new Error('Unknown failure');
                    }
                    return response.json();
                })
                    .then((response) => {
                    if (typeof response.success != 'undefined' && response.success) {
                        document.location.href = '/cart';
                    }
                    else if (typeof response.success != 'undefined' &&
                        response.success === false &&
                        typeof response.error !== 'undefined') {
                        // Wyświetl modal z komunikatem błędu z API
                        MicroModal.close(modal.getAttribute('id') ?? '');
                        const errorModal = document.createElement('tc-modal');
                        errorModal.title = i18n('Openset could not be added');
                        errorModal.innerText = response.error;
                        document.body.append(errorModal);
                        errorModal.open();
                    }
                })
                    .catch((err) => {
                    console.error(err);
                });
            });
        }
    }
}
